module.exports = __webpack_public_path__ + "static/img/industry4.c920370.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/industry4.png
// module id = kU4s
// module chunks = 2